module.exports = __webpack_public_path__ + "img/approve-ccto.c4984640.svg";